import { Button, Dialog, Slide } from '@mui/material';
import React from 'react';
import { colorPrimary, colorTextBlack } from '../../../config/theme';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FlashcardImageModal = ({ image, isOpen, handleClose }) => {
  return (
    <Dialog
      //   maxWidth="xs"
      fullWidth
      open={isOpen || false}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose(event, reason);
        }
      }}
      TransitionComponent={Transition}
      disableEscapeKeyDown
      scroll="body"
      className="custom-dialog"
    >
      <div
        style={{
          display: 'flex',
          padding: '20px',
          flexDirection: 'column',
          width: '100%'
        }}
      >
        <div
          style={{
            display: 'flex',
            width: '100%'
          }}
        >
          <img
            src={image}
            alt="PDF thumbnail"
            style={{
              width: '100%',
              height: '400px',
              borderRadius: '8px'
            }}
          />
        </div>

        <div
          style={{
            display: 'flex'
          }}
        >
          <Button
            size="small"
            color="primary"
            variant="outlined"
            sx={{
              borderColor: colorPrimary,
              borderRadius: '10px',
              color: colorTextBlack,
              borderWidth: '2px',
              height: '42px',
              width: '83px',
              marginTop: '1rem'
            }}
            onClick={handleClose}
          >
            Close
          </Button>
        </div>
        {/*  */}
      </div>
    </Dialog>
  );
};

export default FlashcardImageModal;
